import { render, staticRenderFns } from "./proof-view-pagination.vue?vue&type=template&id=4ee2da2c&scoped=true&"
import script from "./proof-view-pagination.vue?vue&type=script&lang=js&"
export * from "./proof-view-pagination.vue?vue&type=script&lang=js&"
import style0 from "./proof-view-pagination.vue?vue&type=style&index=0&id=4ee2da2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee2da2c",
  null
  
)

export default component.exports